export default "__VITE_ASSET__CNG7N912__"